import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";
import { usePostData } from "~/composables/usePostData";

export const useMerciPronteConsegnaStore = defineStore(
  "merciPronteConsegnaStore",
  {
    state: () => ({
      merciPronteConsegna: [],
      caricandoMerciPronteConsegna: false,
      errorMessage: "",
      caricandoDataConsegna: false
    }),
    actions: {
      async getMerciPronteConsegnaOdoo() {
        const { data, getData, loading, messageError } = useGetData();
        this.caricandoMerciPronteConsegna = true;
        await getData("/api/merci/pronte_consegna");
        if (!messageError.value) {
          this.merciPronteConsegna = data.value;
          this.caricandoMerciPronteConsegna = loading.value;
        } else {
          this.errorMessage = messageError;
        }
      },
      async aggiungiDataConsegnaOdoo(body) {
        const {
          data: result,
          postData,
          messageError: messageErrorPost
        } = usePostData();
        await postData("/api/merci/aggiungi_data_consegna", body);

        if (!messageErrorPost.value) {
          this.aggiornareElemento(result.value.merci);
          this.caricandoDataConsegna = false;
        }

        this.caricandoDataConsegna = false;
      },
      aggiornareElemento(data) {
        for (const merce of data) {
          console.log("merce ", merce);
          const index = this.merciPronteConsegna.findIndex(
            ({ id }) => id === merce.id
          );
          Object.assign(this.merciPronteConsegna[index], merce);
        }
      }
    }
  }
);
